<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('sleep.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-top">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 1}"
                     @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 2}"
                     @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div class="avg-score-box">
                <img class="score-bg" :src="require(`@/assets/theme/${theme}/status/06sleep/07scoreBg.png`)">
                <div class="avg-score-title">{{ $t('sleep.avgScore') }}</div>
                <div class="avg-score-value">{{ noData ? '--' : (sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgScore ? sleepInfo.sleepRangeMath.avgScore : '--') }}</div>
                <div class="compare-box" v-if="!noData && sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgScoreLast != null"><img :src="sleepInfo.sleepRangeMath.avgScore >= sleepInfo.sleepRangeMath.avgScoreLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')"> {{ Math.abs(sleepInfo.sleepRangeMath.avgScore - sleepInfo.sleepRangeMath.avgScoreLast) }}</div>
                <div class="compare-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonth' : 'sleep.vsLastWeek') }}</div>
            </div>
        </div>
        <div>
            <div class="suggest-title">{{ $t('sleep.scoreTitle') }}</div>
            <div class="score-chart-box">
                <div class="score-chart-out">
                    <div id="score-chart"></div>
                    <div id="y-axis-lines">
                        <div style="height: 20%; background-color: var(--chart-color-8);"></div>
                        <div style="height: 20%; background-color: var(--chart-color-1);"></div>
                        <div style="height: 60%; background-color: var(--chart-color-12);"></div>
                    </div>
                </div>

                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-1"
                             :style="{'width': scoreRatioArr[0] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-1"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[0] }}{{ $t('sleep.days') }}</div>
                    <div class="score-num-level">{{ $t('sleep.scoreGe80') }}</div>
                </div>
                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-2"
                             :style="{'width': scoreRatioArr[1] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-2"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[1] }}{{ $t('sleep.days') }}</div>
                    <div class="score-num-level">{{ $t('sleep.score60to79') }}</div>
                </div>
                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-3"
                             :style="{'width': scoreRatioArr[2] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-3"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[2] }}{{ $t('sleep.days') }}</div>
                    <div class="score-num-level">{{ $t('sleep.scoreLe60') }}</div>
                </div>
                <div class="score-suggest">{{ $t('sleep.suggestText') }}</div>
            </div>
            <div class="suggest-title">{{ $t('sleep.hoursVsNeed') }}</div>
            <div class="score-chart-box">
                <div id="duration-chart"></div>
            </div>
            <div class="suggest-title">{{ $t('sleep.sleepEfficiency') }}</div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('sleep.avgSleepEfficiency') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgSleepEfficiency != null ? Math.ceil(sleepInfo.sleepRangeMath.avgSleepEfficiency) : '--') }}</div>
                        <div class="avg-efficiency-unit">%</div>
                        <div class="avg-efficiency-compare" v-if="!noData && sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgSleepEfficiencyLast != null">
                            <img :src="sleepInfo.sleepRangeMath.avgSleepEfficiency >= sleepInfo.sleepRangeMath.avgSleepEfficiencyLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(sleepInfo.sleepRangeMath.avgSleepEfficiency - sleepInfo.sleepRangeMath.avgSleepEfficiencyLast).toFixed(1) }}%</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div class="fall-box" id="efficiency-chart"></div>
            </div>
            <div class="suggest-title">{{ $t('sleep.sleepConsistency') }}</div>
            <div class="score-chart-box">
                <div class="fall-box" id="fall-chart"></div>
            </div>
            <div class="suggest-title">{{ $t('sleep.sleepStage') }}
                <img class="info-icon" @click="toSleepStage"
                     :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
            </div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('sleep.avgRestorativeSleep') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgRestorativeSleep != null ? Math.ceil(sleepInfo.sleepRangeMath.avgRestorativeSleep) : '--') }}</div>
                        <div class="avg-efficiency-unit">%</div>
                        <div class="avg-efficiency-compare" v-if="!noData && sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgRestorativeSleepLast != null">
                            <img :src="sleepInfo.sleepRangeMath.avgRestorativeSleep >= sleepInfo.sleepRangeMath.avgRestorativeSleepLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(sleepInfo.sleepRangeMath.avgRestorativeSleep - sleepInfo.sleepRangeMath.avgRestorativeSleepLast).toFixed(1) }}%</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div id="range-chart" key="myCharts2"></div>
            </div>
            <div class="suggest-title">{{ $t('sleep.sleepStability') }}
                <img class="info-icon" @click="toSleepStage"
                     :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
            </div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('sleep.avgSleepStability') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgSleepStability != null ? Math.ceil(sleepInfo.sleepRangeMath.avgSleepStability) : '--') }}</div>
                        <div class="avg-efficiency-unit">%</div>
                        <div class="avg-efficiency-compare" v-if="!noData && sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgSleepStabilityLast != null">
                            <img :src="sleepInfo.sleepRangeMath.avgSleepStability >= sleepInfo.sleepRangeMath.avgSleepStabilityLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(sleepInfo.sleepRangeMath.avgSleepStability - sleepInfo.sleepRangeMath.avgSleepStabilityLast).toFixed(1) }}%</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div id="stability-chart" key="myCharts2"></div>
            </div>
            <div class="suggest-title">{{ $t('sleep.ahi') }}</div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('sleep.avgAhi') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgSleepStability != null ? sleepInfo.sleepRangeMath.avgSleepStability : '--') }}</div>
                        <div class="avg-efficiency-unit"></div>
                        <div class="avg-efficiency-compare" v-if="!noData && sleepInfo.sleepRangeMath && sleepInfo.sleepRangeMath.avgSleepStabilityLast != null">
                            <img :src="sleepInfo.sleepRangeMath.avgSleepStability <= sleepInfo.sleepRangeMath.avgSleepStabilityLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(sleepInfo.sleepRangeMath.avgSleepStability - sleepInfo.sleepRangeMath.avgSleepStabilityLast).toFixed(1) }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div id="ahi-chart"></div>
                <div class="ahi-legend-box">
                    <div class="ahi-legend-item">
                        <div class="ahi-legend-bar ahi-legend-normal"></div>
                        <span class="ahi-legend-text">{{ $t('sleep.ahiNormal') }}</span>
                    </div>
                    <div class="ahi-legend-item">
                        <div class="ahi-legend-bar ahi-legend-mild"></div>
                        <span class="ahi-legend-text">{{ $t('sleep.ahiMild') }}</span>
                    </div>
                    <div class="ahi-legend-item">
                        <div class="ahi-legend-bar ahi-legend-moderate"></div>
                        <span class="ahi-legend-text">{{ $t('sleep.ahiModerate') }}</span>
                    </div>
                    <div class="ahi-legend-item">
                        <div class="ahi-legend-bar ahi-legend-severe"></div>
                        <span class="ahi-legend-text">{{ $t('sleep.ahiSevere') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr, SwitchTime24,
    changeDate,
    changeMonthDate,
    GetYear,
    GetMinute,
    calculateDuration, getDateWeek, getDateDay, convertTo12Hour
} from "../../utils/dateUtils";
import zh from '@/assets/sleep/zh.json'
import en from '@/assets/sleep/en.json'
import ja from '@/assets/sleep/ja.json'
import VueMarkdown from "vue-markdown";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'sleep',
    components: {VueMarkdown},
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 1,
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            sleepInfo: {},
            sleepAvg: {
                num: 0,
                hour: 0,
                minute: 0
            },
            score: '--',
            showLeftOpacity: 0,
            showRightOpacity: 1,
            fallChart: null,
            scoreChart: null,
            symbol: 0,
            dateSleep: [], // 每日睡眠数据
            sleepDays: 0, // 范围天数
            scoreRatioArr: [0, 0, 0], // >=80、60-70、<60天数占比
            durationChart: null, // 睡眠时长图
            efficiencyChart: null, // 睡眠效率图
            stabilityChart: null, // 睡眠稳定性图
            rangeChart: null, // 睡眠阶段图
            ahiChart: null, // AHI呼吸率图
            noData: true,
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.changeTimeType(1, this.$t('dailyActive.time0'))
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            this.getData();
        },
        getData() {
            this.checkOpacity();
            this.getSleepByRange();
        },
        getSleepByRange() {
            this.$api.status.getSleepByRange({
                startDate: this.startDate,
                endDate: this.endDate,
                type: this.activeTime == 1 ? 'week' : 'month'
            }).then(res => {
                if (res.info && res.info.sleepRangeMath && res.info.sleepRangeMath.avgScore > 0) {
                    this.noData = false
                    this.sleepInfo = res.info
                    this.processSleepData(res.info)
                } else {
                    this.noData = true
                    this.sleepInfo = res.info || {}
                    this.sleepAvg.num = 0
                    this.scoreRatioArr = [0, 0, 0]
                    this.sleepDays = 0
                    // 无数据时也要初始化 echarts 显示空状态
                    const xData = this.generateXAxisData()
                    this.$nextTick(() => {
                        this.drawScoreChart(xData, [])
                        this.drawDurationChart(xData, [[], []])
                        this.drawEfficiencyChart(xData, [])
                        this.drawFallChart(xData, [[], []])
                        this.drawRangeChart(xData, [[], []])
                        this.drawStabilityChart(xData, [])
                        this.drawAhiChart(xData, [])
                    })
                }
            })
        },
        processSleepData(info) {
            // 1. 处理评分分布数据 (scoreRatioArr: >=80, 60-79, <60)
            const math = info.sleepRangeMath || {}
            this.scoreRatioArr = [
                math.scoreGreater80 || 0,
                math.scoreGreater60 || 0,
                math.scoreLess60 || 0
            ]
            this.sleepDays = this.scoreRatioArr[0] + this.scoreRatioArr[1] + this.scoreRatioArr[2]

            // 2. 生成X轴日期数据
            const xData = this.generateXAxisData()

            // 3. 设置avg数据用于图表判断
            this.sleepAvg.num = math.avgScore || 0

            // 4. 提取数据（按完整日期范围，无数据的补null）
            const scoreList = info.scoreList || []
            const count = xData.length
            const mapper = (list, fn) => Array.from({ length: count }, (_, i) => {
                if (!(scoreList[i] > 0)) return null
                return fn(i)
            })

            const allScoreList = mapper(scoreList, i => scoreList[i])
            const timeInbedList = mapper(info.timeInbedSecondList, i =>
                ((info.timeInbedSecondList || [])[i] || 0) / 3600
            )
            const sleepNeedList = mapper(info.sleepNeedSecondList, i =>
                ((info.sleepNeedSecondList || [])[i] || 0) / 3600
            )
            const efficiencyList = mapper(info.sleepEfficiencyList, i =>
                (info.sleepEfficiencyList || [])[i] || 0
            )
            const parseTime = (timeStr) => {
                if (!timeStr) return null
                // 兼容 "23:17:00" 和 "2026-06-05 23:17:00" 两种格式，取最后的时分
                const timeOnly = timeStr.includes(' ') ? timeStr.split(' ')[1] : timeStr
                const parts = timeOnly.split(':')
                return parseInt(parts[0]) + parseInt(parts[1]) / 60
            }
            const betTimeData = mapper(info.betTimeList, i =>
                parseTime((info.betTimeList || [])[i])
            )
            const wakeupTimeData = mapper(info.wakeupTimeList, i =>
                parseTime((info.wakeupTimeList || [])[i])
            )
            // fall-chart 数据：bedtime为基座，wakeupDiff为叠加差值
            // wakeup < bedtime 时 +24（跨午夜），保证wake在bed上方
            const fallBedData = []
            const fallWakeDiffData = []
            for (let i = 0; i < count; i++) {
                const bed = betTimeData[i]
                const wake = wakeupTimeData[i]
                if (bed != null && wake != null) {
                    let adjWake = wake
                    if (adjWake < bed) adjWake += 24
                    fallBedData.push(bed)
                    fallWakeDiffData.push(adjWake - bed)
                } else {
                    fallBedData.push(null)
                    fallWakeDiffData.push(null)
                }
            }
            const stabilityList = mapper(info.sleepStabilityList, i =>
                (info.sleepStabilityList || [])[i] || 0
            )
            const deepRatioList = mapper(info.deepRatioList, i =>
                (info.deepRatioList || [])[i] || 0
            )
            const remRatioList = mapper(info.remRatioList, i =>
                (info.remRatioList || [])[i] || 0
            )

            // ahi 模拟数据：根据睡眠评分生成不同等级的AHI值
            const ahiList = mapper(info.sleepEfficiencyList, i => {
                const score = (info.scoreList || [])[i] || 0;
                if (score >= 90) return Math.random() * 4;           // 正常 <5
                if (score >= 75) return 5 + Math.random() * 10;     // 轻度 5-15
                if (score >= 60) return 16 + Math.random() * 14;    // 中度 16-30
                return 31 + Math.random() * 9;                       // 重度 >30
            })

            // 5. 绘制各图表（始终使用完整xData）
            this.$nextTick(() => {
                this.drawScoreChart(xData, allScoreList)
                this.drawDurationChart(xData, [timeInbedList, sleepNeedList])
                this.drawEfficiencyChart(xData, efficiencyList)
                this.drawFallChart(xData, [fallBedData, fallWakeDiffData])
                this.drawRangeChart(xData, [deepRatioList, remRatioList])
                this.drawStabilityChart(xData, stabilityList)
                this.drawAhiChart(xData, ahiList)
            })
        },
        generateXAxisData() {
            const xData = []
            const start = new Date(this.startDate)
            const end = new Date(this.endDate)
            const current = new Date(start)
            while (current <= end) {
                const dateStr = current.getFullYear() + '-' +
                    (current.getMonth() + 1).toString().padStart(2, '0') + '-' +
                    current.getDate().toString().padStart(2, '0')
                const weekStr = this.$t('sleep.week' + getDateWeek(dateStr))
                xData.push(weekStr + '\n' + getDateDay(dateStr))
                current.setDate(current.getDate() + 1)
            }
            return xData
        },
        toSleepStage() {
            this.$router.push({
                name: 'sleepStage',
                query: {
                    lang: this.$i18n.locale
                }
            })
        },
        drawFallChart(xData, yData) {
            let _this = this;
            this.fallChart = this.$echarts.init(document.getElementById("fall-chart"));
            if (this.sleepAvg.num > 0) {
                const bedData = yData[0] || []
                const wakeDiffData = yData[1] || []
                // 计算动态 y 轴范围
                const validBeds = bedData.filter(v => v != null)
                const validWakeDiffs = wakeDiffData.filter(v => v != null)
                let yMin = 24, yMax = 0
                validBeds.forEach(v => { if (v < yMin) yMin = v })
                validBeds.forEach((bed, i) => {
                    const top = bed + (validWakeDiffs[i] || 0)
                    if (top > yMax) yMax = top
                })
                yMin = Math.floor(yMin) - 1
                yMax = Math.ceil(yMax) + 1
                if (yMax - yMin < 6) { yMin -= 2; yMax += 2 }
                // 根据范围计算合适的均匀刻度间隔
                const yRange = yMax - yMin
                let yInterval = yRange <= 8 ? 2 : yRange <= 16 ? 3 : 4
                yMin = Math.floor(yMin / yInterval) * yInterval
                yMax = Math.ceil(yMax / yInterval) * yInterval

                this.fallChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 53 * this.ratio,
                        right: 20 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let bedTime = params[0] ? params[0].data : null
                            let wakeDiff = params[1] ? params[1].data : null
                            // 实际起床时间 = bedTime + wakeDiff，对24取模回到0-24范围
                            let wakeTime = (bedTime != null && wakeDiff != null) ? (bedTime + wakeDiff) % 24 : null
                            if (bedTime == null && wakeTime == null) return
                            const formatTime = (v) => {
                                if (v == null) return '--'
                                const h = Math.floor(v)
                                const m = Math.round((v - h) * 60)
                                return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0')
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + (params[0] ? params[0].axisValue : '') + '</div>'
                            html += '<div><div style="margin-right: 5px;border-radius: 50%;display: inline-block;width: 7px;height: 7px;background-color:' + getSkin('--chart-color-1') + ' "></div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + formatTime(wakeTime) + '</span> </div></div>';
                            html += '<div><div style="margin-right: 5px;border-radius: 50%;display: inline-block;width: 7px;height: 7px;background-color:' + getSkin('--chart-color-8') + ' "></div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + formatTime(bedTime) + '</span> </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        min: yMin,
                        max: yMax,
                        interval: yInterval,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontFamily: "'D-D','SF'",
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            formatter: function (value) {
                                let h = Math.round(value) % 24
                                return h.toString().padStart(2, '0') + ':00'
                            }
                        }
                    },
                    series: [
                        {
                            name: 'BEDTIME',
                            data: bedData,
                            type: 'line',
                            stack: 'total',
                            lineStyle: {
                                color: getSkin('--chart-color-8'),
                                width: 1 * this.ratio
                            },
                            symbolSize: 7 * this.ratio,
                            symbol: 'circle',
                            itemStyle: {
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-8'),
                                borderWidth: 2
                            },
                            areaStyle: {
                                color: getSkin('--bg-color-2'),
                            },
                            label: {
                                show: true,
                                position: 'bottom',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: function(params) {
                                    const v = params.data
                                    if (v == null) return ''
                                    const h = Math.floor(v)
                                    const m = Math.round((v - h) * 60)
                                    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0')
                                }
                            }
                        }, {
                            name: 'WAKE-UP TIME',
                            data: wakeDiffData,
                            type: 'line',
                            stack: 'total',
                            lineStyle: {
                                color: getSkin('--chart-color-1'),
                                width: 1 * this.ratio
                            },
                            symbolSize: 7 * this.ratio,
                            symbol: 'circle',
                            itemStyle: {
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-1'),
                                borderWidth: 2
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: getSkin('--chart-color-81'),
                                    },
                                    {
                                        offset: 1,
                                        color: getSkin('--chart-color-1p1'),
                                    },
                                ]),
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: function(params) {
                                    const wakeDiff = params.data
                                    const bed = bedData[params.dataIndex]
                                    if (wakeDiff == null || bed == null) return ''
                                    const wakeTime = (bed + wakeDiff) % 24
                                    const h = Math.floor(wakeTime)
                                    const m = Math.round((wakeTime - h) * 60)
                                    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0')
                                }
                            }
                        },
                    ]
                }, true);
            } else {
                this.fallChart.setOption({
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 44 * this.ratio,
                        right: 20 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 75 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let betTime = params[0].data
                            let wakeTime = params[1] ? params[1].data : null
                            if (betTime == null && wakeTime == null) {
                                return
                            }
                            const formatTime = (v) => {
                                if (v == null) return '--'
                                const h = Math.floor(v)
                                const m = Math.round((v - h) * 60)
                                return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0')
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="margin-right: 5px;border-radius: 50%;display: inline-block;width: 7px;height: 7px;background-color:' + getSkin('--chart-color-8') + ' "></div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + formatTime(betTime) + '</span> </div></div>';
                            html += '<div><div style="margin-right: 5px;border-radius: 50%;display: inline-block;width: 7px;height: 7px;background-color:' + getSkin('--chart-color-17') + ' "></div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + formatTime(wakeTime) + '</span> </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontFamily: "'D-D','SF'",
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontFamily: "'D-D','SF'",
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            formatter: function (value) {
                                if (value < 12) {
                                    value = value + 12
                                } else if (value == 12) {
                                    value = 0
                                } else {
                                    value = value - 12
                                }
                                if (value.toString().length == 1) {
                                    value = '0' + value
                                }
                                value = value + ':00'
                                return convertTo12Hour(value)
                            }
                        }
                    },
                    series: [
                        {
                            name: 'BEDTIME',
                            data: yData[0] || [],
                            type: 'line',
                            stack: 'total',
                            lineStyle: {
                                color: getSkin('--chart-color-8'),
                                width: 1 * this.ratio
                            },
                            symbolSize: 7 * this.ratio,
                            symbol: 'circle',
                            itemStyle: {
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-8'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2
                            },
                            areaStyle: {
                                color: getSkin('--bg-color-2'),
                            }
                        }, {
                            name: 'WAKE-UP TIME',
                            data: yData[1],
                            type: 'line',
                            stack: 'total',
                            lineStyle: {
                                color: getSkin('--chart-color-1'),
                                width: 1 * this.ratio
                            },
                            symbolSize: 7 * this.ratio,
                            symbol: 'circle',
                            itemStyle: {
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-1'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: getSkin('--chart-color-81'),
                                    },
                                    {
                                        offset: 1,
                                        color: getSkin('--chart-color-11'),
                                    },
                                ]),
                            }
                        },
                    ]
                }, true);
            }

        },
        getItemColor(value) {
            if (value == null) return 'transparent';
            if (value < 60) return getSkin('--chart-color-124');
            if (value < 80) return getSkin('--chart-color-2');
            return getSkin('--chart-color-84');
        },
        getTopColor(value) {
            if (value == null) return 'transparent';
            if (value < 60) return getSkin('--chart-color-12');
            if (value < 80) return getSkin('--chart-color-1');
            return getSkin('--chart-color-8');
        },
        drawScoreChart(xData, yData) {
            let _this = this;
            // let barWidth = 16 * this.ratio;
            // if (this.activeTime == 1) {
            //     barWidth = 16 * this.ratio;
            // } else {
            //     barWidth = 4 * this.ratio;
            // }
            this.scoreChart = this.$echarts.init(document.getElementById("score-chart"));
            if (this.sleepAvg.num > 0) {
                const validY = yData.filter(v => v != null);
                const maxVal = validY.length > 0 ? Math.max(...validY) : 0;
                const minVal = validY.length > 0 ? Math.min(...validY) : 0;
                this.scoreChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data + 2 : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        z: 2,
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            rich: {
                                color60: {
                                    color: getSkin('--chart-color-5')  // 29 的颜色
                                },
                                color80: {
                                    color: getSkin('--chart-color-1')   // 59 的颜色
                                },
                                color100: {
                                    color: getSkin('--chart-color-8')   // 79 的颜色
                                }
                            },
                            formatter: function (value) {
                                if (Math.abs(value - 60) < 0.1) {
                                    return '{color60|60}';
                                }
                                if (Math.abs(value - 80) < 0.1) {
                                    return '{color80|80}';
                                }
                                if (Math.abs(value - 100) < 0.1) {
                                    return '{color100|100}';
                                }
                                return '';
                            }
                        }
                    },
                    series: [
                        {
                            data: yData.map(val => val == null ? null : val - 2),
                            type: 'bar',
                            stack: 'total',
                            barWidth: '50%',
                            lineStyle: {
                                color: getSkin('--text-color-3'),
                                width: 2 * this.ratio
                            },
                            itemStyle: {
                                color: function (params) {
                                    const realVal = yData[params.dataIndex];
                                    return _this.getItemColor(realVal);
                                },
                                // borderWidth: barWidth,
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    const realVal = yData[params.dataIndex];
                                    if (realVal == null) return '';
                                    if (_this.activeTime == 2) {
                                        // 如果是最大值 或 最小值 → 显示数值
                                        if (realVal === maxVal || realVal === minVal) {
                                            return realVal;
                                        }
                                        // 其他都不显示
                                        return '';
                                    } else {
                                        return realVal;
                                    }

                                }
                            },
                        },
                        // 上层：顶部亮色部分
                        {
                            type: 'bar',
                            barWidth: '40%',
                            stack: 'total',
                            itemStyle: {
                                color: function (params) {
                                    const realValue = yData[params.dataIndex];
                                    return _this.getTopColor(realValue);
                                }
                            },
                            data: yData.map(val => val == null ? null : 2)
                        }
                    ]
                }, true)
                // this.scoreChart.setOption(option);
            } else {
                this.scoreChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }

        },
        drawDurationChart(xData, yData) {
            let _this = this;
            this.durationChart = this.$echarts.init(document.getElementById("duration-chart"));
            if (this.sleepAvg.num > 0) {
                const valid0 = yData[0].filter(v => v != null);
                const valid1 = yData[1].filter(v => v != null);
                const maxVal0 = valid0.length > 0 ? Math.max(...valid0) : 0;
                const minVal0 = valid0.length > 0 ? Math.min(...valid0) : 0;
                const maxVal1 = valid1.length > 0 ? Math.max(...valid1) : 0;
                const minVal1 = valid1.length > 0 ? Math.min(...valid1) : 0;
                this.durationChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data != null ? item.data : 0;
                            let value1 = params[1].data != null ? params[1].data : 0;
                            if (value == null || value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="margin-right: 5px;border-radius: 2px;display: inline-block;width: 10px;height: 8px;background-color:' + getSkin('--chart-color-8') + ' "></div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + Number(value).toFixed(1) + '</span> </div></div>';
                            html += '<div><div style="margin-right: 5px;border-radius: 2px;display: inline-block;width: 10px;height: 8px;background-color:' + getSkin('--chart-color-5') + ' "></div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + Number(value1).toFixed(1) + '</span> </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        interval: 2.5,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            formatter: function (value) {
                                return value + 'h'
                            }
                        }
                    },
                    series: [
                        {
                            name: 'HOURS OF SLEEP',
                            data: yData[0],
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-8'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-8'), // 折线颜色
                            },
                            label: {
                                show: true,
                                position: 'bottom',
                                color: getSkin('--chart-color-8'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.data != null ? Number(params.data).toFixed(1) : '';
                                },
                            },
                        },
                        {
                            name: 'SLEEP NEED',
                            data: yData[1],
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-5'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-5'), // 折线颜色
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--chart-color-5'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.data != null ? Number(params.data).toFixed(1) : '';
                                },
                            },
                        }
                    ]
                }, true)
                // this.scoreChart.setOption(option);
            } else {
                this.durationChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }

        },
        drawEfficiencyChart(xData, yData) {
            let _this = this;
            // let barWidth = 16 * this.ratio;
            // if (this.activeTime == 1) {
            //     barWidth = 16 * this.ratio;
            // } else {
            //     barWidth = 4 * this.ratio;
            // }
            this.efficiencyChart = this.$echarts.init(document.getElementById("efficiency-chart"));
            if (this.sleepAvg.num > 0) {
                const validY = yData.filter(v => v != null);
                const maxVal = validY.length > 0 ? Math.max(...validY) : 0;
                const minVal = validY.length > 0 ? Math.min(...validY) : 0;
                this.efficiencyChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '%</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        interval: 25,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            formatter: function (value) {
                                return value + '%'
                            }
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-8'), // 描边颜色（和你的折线颜色一致）
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-8'), // 折线颜色
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    return params.value + '%';
                                }
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: getSkin('--chart-color-80'),
                                    },
                                    {
                                        offset: 1,
                                        color: getSkin('--chart-color-84'),
                                    },
                                ]),
                            }
                        }
                    ]
                }, true)
                // this.efficiencyChart.setOption(option);
            } else {
                this.efficiencyChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }

        },
        drawRangeChart(xData, yData) {
            let _this = this;
            let barWidth = 18 * this.ratio;
            if (this.activeTime == 1) {
                barWidth = 18 * this.ratio;
            } else {
                barWidth = 4 * this.ratio;
            }
            this.rangeChart = this.$echarts.init(document.getElementById("range-chart"));
            if (this.sleepAvg.num > 0) {
                const valid0 = yData[0].filter(v => v != null);
                const valid1 = yData[1].filter(v => v != null);
                const allValid = valid0.concat(valid1);
                const maxVal = allValid.length > 0 ? Math.max(...allValid) : 0;
                const minVal = allValid.length > 0 ? Math.min(...allValid) : 0;
                this.rangeChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            if (params[0].data == null && (params[1] ? params[1].data == null : true)) {
                                return
                            }
                            let deepVal = params[0].data != null ? params[0].data : 0;
                            let remVal = params[1] ? (params[1].data != null ? params[1].data : 0) : 0;
                            let total = deepVal + remVal;
                            let html = '';
                            html += '<div style="font-size:14px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div style="color: var(--text-color-1); font-size: 13px;font-family:D-D"><span style="color: var(--text-color-1);font-size: 20px;">' + Math.floor(total) + '</span> <span style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">%</span></div>'
                            html += '<div style="color: var(--text-color-1); font-size: 13px;font-family:D-D"><span style="color: var(--chart-color-1);margin-right: 5px;">'+ _this.$t('sleep.stage0') +'</span>' +  Math.floor(deepVal) + '%</div>'
                            html += '<div style="color: var(--text-color-1); font-size: 13px;font-family:D-D"><span style="color: var(--chart-color-8);margin-right: 5px;">'+ _this.$t('sleep.stage1') +'</span>' + Math.floor(remVal) + '%</div>'
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 80,
                        boundaryGap: [0, '10%'],
                        interval: 20,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            formatter: function (value) {
                                return value + '%'
                            }
                        }
                    },
                    series: [
                        {
                            name: 'Deep',
                            data: yData[0],
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            label: { show: false },
                            itemStyle: {
                                color: getSkin('--chart-color-8'),
                                borderRadius: 2 * this.ratio,
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-84'),
                                    borderRadius: 2 * this.ratio,
                                }
                            },
                        },
                        {
                            name: '',
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            data: yData[0].map(v => v == null ? null : 2),
                            itemStyle: { color: 'rgba(0,0,0,0)' },
                            tooltip: {show: false },
                            legendHoverLink: false
                        },
                        {
                            name: 'REM',
                            data: yData[1],
                            type: 'bar',
                            stack: 'total',
                            barWidth: barWidth,
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * _this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    if (params.data == null) return '';
                                    const deep = yData[0][params.dataIndex];
                                    const rem = yData[1][params.dataIndex];
                                    if (deep == null && rem == null) return '';
                                    const total = (deep || 0) + (rem || 0);
                                    if (_this.activeTime == 2) {
                                        if (total === maxVal || total === minVal) {
                                            return total;
                                        }
                                        return '';
                                    } else {
                                        return total + '%';
                                    }
                                }
                            },
                            itemStyle: {
                                color: getSkin('--chart-color-1'),
                                borderRadius: 2 * this.ratio,
                            },
                            emphasis: {
                                itemStyle: {
                                    color: getSkin('--chart-color-14'),
                                    borderRadius: 2 * this.ratio,
                                }
                            },
                        }
                    ]
                }, true)
            } else {
                this.rangeChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 72 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        bottom: 12 * this.ratio,
                        right: 16 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-1'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: { color: getSkin('--line-color-2') }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: { show: false },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: { type: 'dotted', color: getSkin('--line-color-3') }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [{ data: [], type: 'bar' }]
                }, true)
            }
        },
        drawStabilityChart(xData, yData) {
            let _this = this;
            // let barWidth = 16 * this.ratio;
            // if (this.activeTime == 1) {
            //     barWidth = 16 * this.ratio;
            // } else {
            //     barWidth = 4 * this.ratio;
            // }
            this.stabilityChart = this.$echarts.init(document.getElementById("stability-chart"));
            if (this.sleepAvg.num > 0) {
                const validY = yData.filter(v => v != null);
                const maxVal = validY.length > 0 ? Math.max(...validY) : 0;
                const minVal = validY.length > 0 ? Math.min(...validY) : 0;
                this.stabilityChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        interval: 25,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'"
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            symbol: 'circle', // 标记点形状：圆形
                            symbolSize: 7 * this.ratio,   // 标记点大小
                            itemStyle: {
                                // 关键：填充色设为透明，描边色设为蓝色
                                color: getSkin('--bg-color-2'),
                                borderColor: getSkin('--chart-color-13'),
                                borderWidth: 2          // 描边粗细，控制圆环宽度
                            },
                            lineStyle: {
                                color: getSkin('--chart-color-13'), // 折线颜色
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                            },
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: getSkin('--chart-color-130'),
                                    },
                                    {
                                        offset: 1,
                                        color: getSkin('--chart-color-13'),
                                    },
                                ]),
                            }
                        }
                    ]
                }, true)
                // this.stabilityChart.setOption(option);
            } else {
                this.stabilityChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }

        },
        drawAhiChart(xData, yData) {
            let _this = this;
            const getLevel = (v) => {
                if (v < 5) return 'normal';
                if (v <= 15) return 'mild';
                if (v <= 30) return 'moderate';
                return 'severe';
            };
            const getColor = (v) => {
                if (v < 5) return getSkin('--chart-color-1');
                if (v <= 15) return getSkin('--chart-color-15');
                if (v <= 30) return getSkin('--chart-color-5');
                return getSkin('--chart-color-3');
            };
            const getLevelText = (v) => {
                if (v < 5) return _this.$t('sleep.ahiNormal');
                if (v <= 15) return _this.$t('sleep.ahiMild');
                if (v <= 30) return _this.$t('sleep.ahiModerate');
                return _this.$t('sleep.ahiSevere');
            };
            this.ahiChart = this.$echarts.init(document.getElementById("ahi-chart"));
            if (this.sleepAvg.num > 0) {
                const data_style = [];
                for (let i = 0; i < yData.length; i++) {
                    const v = yData[i];
                    if (v == null) continue;
                    data_style.push({
                        value: [i, v],
                        itemStyle: {
                            // 关键：填充色设为透明，描边色设为蓝色
                            color: getSkin('--bg-color-2'),
                            borderColor: getColor(v),
                            borderWidth: 2          // 描边粗细，控制圆环宽度
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: getColor(v),
                            fontSize: 11 * this.ratio,
                            fontWeight: 'bold',
                        },
                    });
                }
                this.ahiChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'item',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params;
                            let value = item.value ? item.value[1] : 0;
                            let level = getLevelText(value);
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + xData[item.value[0]].replace('\n', ' ') + '</div>';
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + (value != null ? value.toFixed(1) : '--') + '</span> events/h</div>';
                            html += '<div style="font-size:12px;color: ' + getColor(value) + ';margin-top:2px;">' + level + '</div>';
                            return html;
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: { color: getSkin('--line-color-2') }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: { show: false },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        min: 0,
                        max: 40,
                        interval: 10,
                        boundaryGap: [0, '5%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'"
                        }
                    },
                    series: [{
                        data: data_style,
                        type: 'scatter',
                        symbolSize: 7 * this.ratio,
                    }]
                }, true);
            } else {
                this.ahiChart.setOption({
                    grid: {
                        top: 17 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: { color: getSkin('--line-color-2') }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: { show: false },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [{
                        data: [],
                        type: 'scatter'
                    }]
                }, true);
            }
        },
        toAI() {
            this.$router.push({
                name: 'checkupDeepSeek',
                query: {
                    lang: this.$i18n.locale,
                    date: this.startDate,
                    type: 1
                }
            })
        },
        toShort() {
            this.$router.push({
                name: 'sleepShort',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme,
                    shortSleep: this.sleepInfo.shortSleep
                }
            })
        }
    },
    unmounted() {
        document.removeEventListener('click', this.checkClick);
    }
}
</script>

<style scoped>

.score-level {
    font-size: 15px;
    color: var(--chart-color-17);
    width: 100%;
    text-align: center;
    margin-left: 8px;
}

.day-box {
    width: 345px;
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
}

.date-item {
    color: var(--text-color-2);
    font-size: 13px;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    margin-top: 8px;
}

.date-item img {
    margin-right: 2px;
    width: 14px;
}

.sleep-start {
    float: left;
    margin-top: 5px;
}

.sleep-end {
    float: right;
    margin-top: 5px;
    text-align: right;
}

.sleep-start-box {
    height: 38px;
}

.sleep-ratio-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 13px auto;
    padding-top: 15px;
    padding-bottom: 1px;
}

.info-icon {
    width: 16px;
    margin-left: 6px;
}

.ratio-line div:first-child {
    border-radius: 5px 0px 0px 5px;
}

.ratio-line div:last-child {
    border-radius: 0px 5px 5px 0px;
}

.ratio-line div:only-child {
    border-radius: 5px 5px 5px 5px;
}

.desc-time span {
    font-size: 15px;
}

.desc-num {
    color: var(--text-color-1);
    font-size: 24px !important;
    margin: 0 3px;
}

.split {
    height: 15px;
}

.suggest-title {
    color: var(--text-color-2);
    font-size: 15px;
    margin-left: 15px;
    margin-top: 16px;
    letter-spacing: 2px;
    display: flex;
}

#range-chart {
    height: 186px;
    width: 100%;
}

.sleep-math-box {
    width: 345px;
    height: 72px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 20px;
}

.math-item {
    text-align: center;
    margin-top: 11px;
}

.math-num {
    font-size: 13px;
    color: var(--text-color-2);
}

.math-text {
    font-size: 13px;
    color: var(--text-color-2);
    margin-top: 7px;
}

.arr-opacity {
    opacity: 0.2;
}

.content-top {
    width: 100%;
    margin-top: 88px;
}

.separate {
    height: 17px;
}

.ratio-num {
    font-size: 15px;
    color: var(--text-color-1);
    text-align: right;
}

.other-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 13px auto;
    display: flex;
}

.stage-box {
    width: 321px;
    height: 62px;
    background: var(--bg-color-1);
    border-radius: 12px;
    margin: 0 auto 8px;
    position: relative;
}

.stage-box-split {
    height: 13px;
}

.stage-bar {
    width: 4px;
    height: 9px;
    border-radius: 1px;
    position: absolute;
    left: 12px;
    top: 17px;
}

.stage-bar1 {
    background: var(--chart-color-17);
}

.stage-bar2 {
    background: var(--chart-color-8);
}

.stage-bar3 {
    background: var(--chart-color-1);
}

.stage-bar4 {
    background: var(--chart-color-12);
}

.stage-key {
    font-size: 13px;
    color: var(--text-color-1);
    position: absolute;
    left: 20px;
    top: 14px;
    line-height: 18px;
}

.stage-value {
    font-size: 20px;
    color: var(--text-color-1);
    position: absolute;
    right: 16px;
    top: 8px;
    line-height: 18px;
    letter-spacing: 2px;
}

.stage-unit {
    font-size: 11px;
    color: var(--text-color-1);
    line-height: 15px;
}

.fall-box {
    width: 345px;
    height: 215px;
}

.average-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 13px auto;
}

/deep/ .van-progress {
    border-radius: 20px;
}

/deep/ .van-progress__pivot {
    display: none !important;
}

.average-desc {
    font-size: 13px;
    color: var(--text-color-2);
    width: 300px;
    margin-left: 16px;
    line-height: 18px;
    letter-spacing: 0.5px;
}

.score-chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 13px auto 20px;
}

.score-chart-out {
    width: 345px;
    height: 190px;
    position: relative;
}

#score-chart {
    width: 345px;
    height: 190px;
}

.average-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin-left: 16px;
    margin-top: 10px;
    margin-bottom: 5px;
    letter-spacing: 2px;
}

.current-month {
    width: 238px;
    height: 18px;
    border-radius: 9px 9px 9px 9px;
    margin-left: 16px;
    background-color: var(--chart-color-17);
}

.big-month {
    width: 307px !important;
}

.last-month {
    width: 238px;
    height: 18px;
    background: #9DACB7;
    border-radius: 9px 9px 9px 9px;
    margin-left: 16px;
}

.current-month-text {
    font-size: 13px;
    color: #ffffff;
    margin-left: 7px;
    line-height: 18px;
}

.last-month-text {
    font-size: 13px;
    color: #000000;
    margin-left: 7px;
    line-height: 18px;
}

.sleep-suggest {
    padding: 12px 16px;
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    width: 305px;
    letter-spacing: 0.5;
}

.day-title {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 15px;
    letter-spacing: 2px;
    margin-top: 14px;
}

.day-num {
    font-size: 40px;
    letter-spacing: 0.5px;
}

.day-hour {
    font-size: 16px;
    color: var(--text-color-2);
    margin: 0 4px;
}

.day-value {
    font-size: 0;
}

.one-day-stage {
    display: flex;
    margin-top: 16px;
}

.stage-item {
    height: 60px;
    border-radius: 3px 3px 3px 3px;
    margin-right: 2px;
}

.typical {
    margin-right: 6px;
    width: 8px;
    height: 12px;
    background: var(--text-color-52);
    border-left: 2px dashed var(--text-color-1);
    border-right: 2px dashed var(--text-color-1);
}

.typical-title {
    font-size: 10px;
    color: var(--text-color-1);
}

.typical-title-line {
    width: 343px;
    margin: 12px auto 7px;
    font-size: 0;
    height: 16px;
}

.typical-type {
    font-size: 13px;
    color: var(--text-color-1);
    letter-spacing: 2px;
    margin-right: 8px;
}

.typical-deep {
    font-size: 13px;
    color: var(--chart-color-17);
    letter-spacing: 0.5px;
}

.typical-light {
    font-size: 13px;
    color: var(--chart-color-8);
    letter-spacing: 0.5px;
}

.typical-rem {
    font-size: 13px;
    color: var(--chart-color-1);
    letter-spacing: 0.5px;
}

.typical-wake {
    font-size: 13px;
    color: var(--chart-color-12);
    letter-spacing: 0.5px;
}

.typical-level {
    width: 76px;
    height: 14px;
    border-radius: 3px 3px 3px 3px;
    font-size: 13px;
    letter-spacing: 2px;
    text-align: center;
    line-height: 14px;
    margin-right: 10px;
}

.typical-normal {
    background: var(--chart-color-82);
    color: var(--chart-color-8);
}

.typical-low {
    background: var(--text-color-22);
    color: var(--text-color-2);
}

.typical-high {
    background: var(--chart-color-52);
    color: var(--chart-color-5);
}

.typical-left {
    display: flex;
    align-items: center;
    float: left;
    width: 50%;
}

.typical-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    float: right;
    width: 50%;
}

.typical-bar {
    text-align: center;
    font-size: 0;
    position: relative;
    width: 343px;
    margin: 0 auto 13px;
}

.bar-bg {
    width: 343px;
    margin: 0 auto;
    height: 16px;
}

.typical-icon {
    background: var(--text-color-52);
    border-left: 2px dashed var(--text-color-1);
    border-right: 2px dashed var(--text-color-1);
    position: absolute;
    z-index: 111;
    height: 18px;
    top: -1px;
}

.deep-typical {
    width: 137.2px;
    left: 68.6px;
}

.light-typical {
    width: 188.65px;
    left: 0;
}

.rem-typical {
    width: 68.6px;
    left: 34.3px;
}

.wake-typical {
    width: 12px;
    left: 0;
}

.typical-ratio {
    height: 16px;
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    left: 0;
    top: 0;
}

.deep-ratio {
    background: var(--chart-color-17);
}

.light-ratio {
    background: var(--chart-color-8);
}

.rem-ratio {
    background: var(--chart-color-1);
}

.wake-ratio {
    background: var(--chart-color-12);
}

.typical-box {
    margin-bottom: 24px;
}

.no-stage {
    width: 343px;
    height: 60px;
    background: var(--bg-color-2);
    border-radius: 3px 3px 3px 3px;
    font-size: 12px;
    letter-spacing: 2px;
    text-align: center;
    line-height: 60px;
}

.avg-score-box {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    text-align: center;
}

.score-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 200px;
}

.avg-score-title {
    position: absolute;
    top: 60px;
    width: 200px;
    font-size: 13px;
    color: var(--text-color-3);
}

.avg-score-value {
    position: absolute;
    top: 74px;
    font-size: 44px;
    color: var(--text-color-1);
    width: 200px;
}

.compare-box {
    font-size: 13px;
    color: var(--chart-color-1);
    width: 200px;
    position: absolute;
    top: 120px;
}

.compare-text {
    font-size: 11px;
    color: var(--text-color-3);
    position: absolute;
    top: 140px;
    width: 200px;
}

.score-item {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
}

.score-img-box {
    position: relative;
    width: 140px;
}

.score-img {
    position: absolute;
    width: 140px;
    height: 14px;
}

.score-color-bar {
    width: 2px;
    height: 14px;
    border-radius: 3px;
    position: absolute;
    right: 0;
}

.score-color-1 {
    background: var(--chart-color-8);
}

.score-color-2 {
    background: var(--chart-color-1);
}

.score-color-3 {
    background: var(--chart-color-12);
}

.score-ratio {
    height: 14px;
    border-radius: 3px;
    position: absolute;
    left: 0;
}

.score-text {
    font-size: 13px;
    color: var(--text-color-1);
    margin: 0 0 0 9px;
    width: 57px;
}

.score-num-level {
    font-size: 13px;
    color: var(--text-color-3);
    width: 50px;
    float: left;
}

.score-suggest {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    margin: 0 16px;
    padding-bottom: 16px;
}

#duration-chart {
    width: 345px;
    height: 211px;
}

.avg-duration-box {
    width: 100%;
    margin-left: 12px;
    margin-bottom: 12px;
}

.avg-duration-title {
    font-size: 13px;
    color: var(--text-color-1);
    padding-top: 16px;
    margin-left: 16px;
    margin-bottom: 4px;
}

.avg-efficiency-value {
    font-size: 20px;
    color: var(--text-color-1);
    margin-left: 16px;
}

.avg-efficiency-unit {
    font-size: 13px;
    color: var(--text-color-1);
    margin-left: 4px;
    margin-right: 8px;
}

.avg-efficiency-compare {
    background: var(--chart-color-1p1);
    border-radius: 3px 3px 3px 3px;
    color: var(--chart-color-1);
    font-size: 13px;
    padding: 2px 4px;
}

.avg-efficiency-line {
    display: flex;
    align-items: center;
}

.avg-efficiency-compare-value {
    margin-left: 5px;
}

.avg-duration-process {
    width: 280px;
    height: 4px;
    margin: 9px auto;
    background-color: var(--chart-color-8);
}

.avg-time-asleep {
    background-color: var(--chart-color-17);
    height: 4px;
}

.avg-consistency-process {
    width: 280px;
    height: 4px;
    margin: 9px auto;
    position: relative;
}

.avg-need-met {
    position: absolute;
    background-color: var(--chart-color-8);
    height: 4px;
}

.consistency-bg {
    position: absolute;
    width: 280px;
    height: 4px;
}

.duration-time-box {
    display: flex;
    justify-content: space-between;
    margin: 8px 20px 0;
}

.duration-time-num {
    font-size: 16px;
    font-weight: bold;
}

.duration-time-num-asleep {
    color: var(--chart-color-17);
}

.duration-time-num-in-bed {
    color: var(--chart-color-8);
}

.duration-time-text {
    font-size: 11px;
    color: var(--text-color-2);
}

.need-met-left {
    font-size: 13px;
    display: flex;
    width: 70%;
    align-items: center;
}

.need-met-right {
    font-size: 13px;
    color: var(--text-color-2);
}

.need-met-box {
    margin-top: 11px;
}

.need-met-num {
    font-size: 20px;
    color: var(--chart-color-8);
    margin-right: 2px;
}

.stage-suggest {
    padding: 4px 8px;
    background-color: var(--chart-color-1p1);
    color: var(--chart-color-1);
    font-size: 13px;
    position: absolute;
    right: 8px;
    bottom: 8px;
    border-radius: 7px;
}

#y-axis-lines {
    position: absolute;
    left: 41px;
    top: 17px;
    width: 2px;
    bottom: 47px;
}

.vs-line {
    display: flex;
    justify-content: space-between;
}

.vs-text {
    font-size: 11px;
    color: var(--text-color-3);
    margin-right: 16px;
}

#stability-chart {
    width: 345px;
    height: 190px;
}

#ahi-chart {
    width: 345px;
    height: 190px;
}

.ahi-legend-box {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding-bottom: 12px;
}

.ahi-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.ahi-legend-bar {
    width: 8px;
    height: 8px;
    border-radius: 2px;
}

.ahi-legend-normal {
    background-color: var(--chart-color-1);
}

.ahi-legend-mild {
    background-color: var(--chart-color-15);
}

.ahi-legend-moderate {
    background-color: var(--chart-color-5);
}

.ahi-legend-severe {
    background-color: var(--chart-color-3);
}

.ahi-legend-text {
    font-size: 11px;
    color: var(--text-color-1);
}
</style>



// WEBPACK FOOTER //
// src/views/status/06sleep.vue